import { useQuery } from '@tanstack/react-query';
import { EpisodeReadRecordApi } from 'api/ApiHelper';
import { episodeReadRecordQueryKey } from 'queries/episodeReadRecord/queryKey';

export const useGetEpisodeReadRecordsQuery = (contentId: number, enabled = false) =>
  useQuery({
    queryKey: episodeReadRecordQueryKey.episodeReadRecord(contentId),
    queryFn: async () => EpisodeReadRecordApi.getLatestReadPerEpisodesByContentId(contentId),
    enabled,
  });
